// extracted by mini-css-extract-plugin
export default {"tasksList":"Tasks_tasksList__sFmVc"};